// removed by extract-text-webpack-plugin
module.exports = {"topWrap":"qempo_SummaryModal_topWrap-2aF6Qs1","textWrap":"qempo_SummaryModal_textWrap-3gJMYui","title":"qempo_SummaryModal_title-37ilxhi","subtitle":"qempo_SummaryModal_subtitle-2DN63la","contentWrap":"qempo_SummaryModal_contentWrap-1cTPr3V","infoWrap":"qempo_SummaryModal_infoWrap-24Xi8P6","couponInfoWrap":"qempo_SummaryModal_couponInfoWrap-1BkYI57"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/new-order/ProductStep/components/NewProductForm/QuoteBox/SummaryModal/SummaryModal.scss
// module id = 1608
// module chunks = 0